var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 752,
    height: 668,
    viewBox: "0 0 752 668",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375.993 251.008V384.34ZM375.993 517.673H376.327ZM329.837 80.7317L55.673 554.287C40.466 580.553 32.8627 593.687 33.9863 604.463C34.9667 613.867 39.8923 622.41 47.5377 627.967C56.3027 634.34 71.4783 634.34 101.829 634.34H650.153C680.507 634.34 695.68 634.34 704.447 627.967C712.09 622.41 717.017 613.867 717.997 604.463C719.12 593.687 711.517 580.553 696.31 554.287L422.147 80.7317C406.997 54.5597 399.42 41.4737 389.537 37.0783C380.913 33.2447 371.07 33.2447 362.45 37.0783C352.563 41.4737 344.987 54.5597 329.837 80.7317Z",
    fill: "#74F5FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M375.993 251.008V384.34M375.993 517.673H376.327M329.837 80.7317L55.673 554.287C40.466 580.553 32.8627 593.687 33.9863 604.463C34.9667 613.867 39.8923 622.41 47.5377 627.967C56.3027 634.34 71.4783 634.34 101.829 634.34H650.153C680.507 634.34 695.68 634.34 704.447 627.967C712.09 622.41 717.017 613.867 717.997 604.463C719.12 593.687 711.517 580.553 696.31 554.287L422.147 80.7317C406.997 54.5597 399.42 41.4737 389.537 37.0783C380.913 33.2447 371.07 33.2447 362.45 37.0783C352.563 41.4737 344.987 54.5597 329.837 80.7317Z",
    stroke: "black",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlue);
export default __webpack_public_path__ + "static/media/icon-blue.fb85039f7d315483be7be714c1590686.svg";
export { ForwardRef as ReactComponent };